import React from 'react';
export function AnnouncementBar() {
  return <div className="bg-sage-primary text-forest py-2 text-center text-sm font-medium" data-id="element-15">
      Edición 2024 · Estrategia de Nutrición Crono-Sincronizada
    </div>;
}